import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdvertisersDetailComponent } from './advertisers-detail/advertisers-detail.component';
import { AdvertisersComponent } from './advertisers/advertisers.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  //{ path:'', component: AdvertisersComponent },
  //{ path: '', redirectTo: '/advertisers', pathMatch: 'full' },
  { path: 'advertisers', component: AdvertisersComponent },
  { path: 'Details/:advFriendlyName', component: AdvertisersDetailComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
